import React from 'react';

export function filterCatalogItems(items, query) {
  const search = query.trim().toLowerCase();
  if (!search) return items;
  return items.filter((item) => String(item.name || item.id || '').toLowerCase().includes(search));
}

export default function CatalogFilter({ label, value, onChange, count, total }) {
  return (
    <div className="catalog-filter">
      <label>
        <span>{label}</span>
        <input type="search" value={value} onChange={(event) => onChange(event.target.value)}
          placeholder="Filter by title" />
      </label>
      {value && <button type="button" onClick={() => onChange('')} aria-label={`Clear ${label.toLowerCase()}`}>Clear</button>}
      <span className="catalog-filter-count" role="status">{count} of {total}</span>
    </div>
  );
}
